import { render, staticRenderFns } from "./OnboardingAllie.vue?vue&type=template&id=5141fa40&"
import script from "./OnboardingAllie.vue?vue&type=script&lang=js&"
export * from "./OnboardingAllie.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingAllie.vue?vue&type=style&index=0&id=5141fa40&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports